import styled from "styled-components";

import Theme from "./../../styles/Theme";

export const ContactWrapper = styled.section`
  background: ${Theme.color.mainBlack};
  padding-top: 7rem;
  padding-bottom: 5rem;
`;

export const FormWrapper = styled.div`
  display: grid;
  place-items: center;
  padding-top: 3rem;
`;
